<template lang="html">
  <div class="loading-page" :class="isLoading ? 'loading-visible' : 'loading-hidden'">
    <iframe src="/loading.html"></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: mapState('loading', [
    'isLoading'
  ])
};
</script>
<style lang="scss" scoped>
.loading-visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 375ms ease-in;
}

.loading-hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 200ms, opacity 200ms ease-out;
}

.loading-page {
  animation: fade 1s linear;
  position: fixed;
  z-index: 99999;
}

iframe {
  height: 100vh !important;
  width: 100vw !important;
  border: 0 none !important;
  opacity: 0.8 !important;
}
</style>